import autobind from 'autobind-decorator';
import * as React from 'react';
import {withTranslation, WithTranslation} from 'react-i18next';
import {Col, Row, Spin} from 'antd';
import {connect} from 'redux-scaffolding-ts';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import * as projecttaskassignmentsStore from 'src/stores/projecttaskassignments-store';
import {NewProjectTaskAssignmentItem, NewProjectTaskAssignmentStore} from 'src/stores/projecttaskassignments-store';
import * as dataStore from 'src/core/stores/dataStore';
import {GridTableView, SpaceMap} from 'src/components/collections/grid-table';
import HttpService from 'src/core/services/http.service';
import {ProjectStore} from 'src/stores/projects-store';
import {ProjectTaskItemsStore, ProjectTaskSummary} from 'src/stores/projecttasks-store';
import {ProjectMemberItemsStore, ProjectMemberSummary} from 'src/stores/projectmembers-store';
import {resolve} from 'src/inversify.config';
import {CacheProps, withCache} from 'src/core/services/cache.service';
import {IdentityProps, withIdentity} from 'src/core/services/authentication';
import {CommandResult} from 'src/core/stores/types';
import ContentTitle from 'src/core/ui/content-header';

interface ProjectTaskAssignmentsViewProps extends RouteComponentProps<{ companyId: string, projectId: string }>, WithTranslation, CacheProps, IdentityProps {
    projectName: string | undefined;
    refresh: boolean;
    onRefresh: () => void;
    companyAllowCir: boolean,
    companyAllowCii: boolean,
}

interface ProjectTaskAssignmentsViewState {
    query: dataStore.Query;
    projectTaskQuery: dataStore.Query;
    projectMembersQuery: dataStore.Query;
    gridAssignmentsData: projecttaskassignmentsStore.ProjectTaskAssignmentSummary[];
    newProjectTaskAssignmentShown: boolean;
    isGridViewActive: boolean;
}

@connect(['projectTasksAssingments', projecttaskassignmentsStore.ProjectTaskAssignmentsStore], ['project', ProjectStore], ['projectmembers', ProjectMemberItemsStore], ['projectTasks', ProjectTaskItemsStore], ["newProjectTaskAssignment", NewProjectTaskAssignmentStore])
class ProjectTaskAssignmentsDashboard extends React.Component<ProjectTaskAssignmentsViewProps, ProjectTaskAssignmentsViewState> {
    @resolve(HttpService)
    private httpService!: HttpService;

    private get newProjectTaskAssignmentStore() {
        return (this.props as any).newProjectTaskAssignment as NewProjectTaskAssignmentStore;
    }

    private get projectMembersStore() {
        return (this.props as any).projectmembers as ProjectMemberItemsStore;
    }
    private get projectAssingmentsStore() {
        return (this.props as any).projectTasksAssingments as projecttaskassignmentsStore.ProjectTaskAssignmentsStore;
    }
    private get projectTasksStore() {
        return (this.props as any).projectTasks as ProjectTaskItemsStore;
    }
    private get projectStore() {
        return (this.props as any).project as ProjectStore;
    }

    constructor(props: ProjectTaskAssignmentsViewProps) {
        super(props);
        var query = { searchQuery: '', orderBy: [{ field: 'employeeTitle', direction: 'Ascending', useProfile: true }], skip: 0, take: 10 }

        this.state = {
            isGridViewActive: true,
            gridAssignmentsData: [],
            query: query as any,
            projectTaskQuery: { searchQuery: '', orderBy: [{ field: 'title', direction: 'Ascending', useProfile: true }], skip: 0, take: 10 },
            projectMembersQuery: { searchQuery: '', orderBy: [{ field: 'title', direction: 'Ascending', useProfile: true }], skip: 0, take: 10 },
            newProjectTaskAssignmentShown: false,
        };
    }
    componentWillMount() {
        this.loadGridData(
            { searchQuery: '', orderBy: [{ field: 'employeeTitle', direction: 'Ascending', useProfile: true }], skip: 0, take: 10 },
            { searchQuery: '', orderBy: [{ field: 'title', direction: 'Ascending', useProfile: true }], skip: 0, take: 10 })
    }
    @autobind
    private async loadGridData(membersQuery: dataStore.Query, projectTasksQuery: dataStore.Query) {
        //get project members
        this.projectMembersStore.changeUrlByProjectEmployee(this.props.match.params.companyId);
        var projectMembers = await this.projectMembersStore.getAllAsync(membersQuery)

        //get project tasks
        this.projectTasksStore.changeUrlByProjectEmployee(this.props.match.params.companyId);
        var projectTasks = await this.projectTasksStore.getAllAsync(projectTasksQuery)

        let requestItem = {
            taskIds: projectTasks.items.map(x => x.id),
            employeeIds: projectMembers.items.map(x => x.employeeId)
        } as projecttaskassignmentsStore.ProjectTaskAssignmentTableRequestItem

        this.loadGridAssignmentsData(requestItem)
    }

    @autobind
    private loadGridAssignmentsData(requestItem: projecttaskassignmentsStore.ProjectTaskAssignmentTableRequestItem) {
        this.httpService.post<projecttaskassignmentsStore.ProjectTaskAssignmentTableRequestItem, any>(
            `${process.env.PUBLIC_URL}/api/v1/companies/${this.props.match.params.companyId}/projects/tableAssignment`, requestItem).then(result => {
                this.setState({ gridAssignmentsData: result.data.items })
            })
    }

    @autobind
    private async onSaveNewGridItem(employeeId: string, taskId: string): Promise<CommandResult<any>> {
        let newItem = {
            employeeId: employeeId,
            projectTaskId: [taskId],
            projectId: this.props.match.params.companyId
        } as NewProjectTaskAssignmentItem
        this.newProjectTaskAssignmentStore.changeUrlProjectMember(this.props.match.params.companyId, taskId);
        this.newProjectTaskAssignmentStore.createNew(newItem);
        return this.newProjectTaskAssignmentStore.submit()
    }

    @autobind
    private async onDeleteGridItem(employeeId: string, taskId: string, assignmentId: string): Promise<CommandResult<any>> {
         let newItem = {
            employeeId: employeeId,
            projectTaskId: [taskId],
            projectId: assignmentId
        } as NewProjectTaskAssignmentItem
        this.projectAssingmentsStore.changeUrlByDeleteProjectMember(this.props.match.params.companyId, taskId);
        return this.projectAssingmentsStore.deleteAsync(assignmentId);
    }

    public render() {
        const { t } = this.props as any;
        var tasksSpaceMap = {
            model: {
                query: this.state.projectTaskQuery,
                data: this.projectTasksStore.state,
                onQueryChanged: (query) => {
                    this.projectTasksStore.changeUrlByProjectEmployee(this.props.match.params.companyId);
                    this.projectTasksStore.getAllAsync(query).then(async (result) => {
                        this.setState({ projectTaskQuery: query })
                        let requestItem = {
                            taskIds: result.items.map(x => x.id),
                            employeeIds: this.projectMembersStore.state.items.map(x => x.item.employeeId)
                        } as projecttaskassignmentsStore.ProjectTaskAssignmentTableRequestItem
                        this.loadGridAssignmentsData(requestItem);
                    })
                }
            },
            width: 250,
            itemKey: "id",
            itemText: "title",
            key: "tasks",
            title: t("Projects"),
            ellipsis: true
        } as SpaceMap<ProjectTaskSummary>

        var membersSpaceMap = {
            model: {
                query: this.state.projectMembersQuery,
                data: this.projectMembersStore.state,
                onQueryChanged: (query) => {
                    this.projectMembersStore.changeUrlByProjectEmployee(this.props.match.params.companyId);
                    this.projectMembersStore.getAllAsync(query).then(async (result) => {
                        this.setState({ projectMembersQuery: query })
                        let requestItem = {
                            taskIds: this.projectTasksStore.state.items.map(x => x.item.id),
                            employeeIds: result.items.map(x => x.employeeId)
                        } as projecttaskassignmentsStore.ProjectTaskAssignmentTableRequestItem
                        this.loadGridAssignmentsData(requestItem);
                    })
                }
            },
            width: 50,
            height: 200,
            showSideways: true,
            itemKey: "employeeId",
            itemText: "employeeTitle",
            key: "members",
            title: t("Employees"),
            ellipsis: true
        } as SpaceMap<ProjectMemberSummary>
        var assingmentsSpaceMap = {
            model: {
                query: { searchQuery: '', orderBy: [{ field: 'employeeTitle', direction: 'Ascending', useProfile: true }], skip: 0, take: 10 },
                data: this.projectAssingmentsStore.state,
                onQueryChanged: () => { }
            },
            alternativeDataSource: this.state.gridAssignmentsData,
            itemKey: "id",
            itemText: "title",
            key: "assingments",
            title: "assingments"
        } as SpaceMap<projecttaskassignmentsStore.ProjectTaskAssignmentSummary>

        return <Spin size='large' spinning={this.projectTasksStore.state.isBusy || this.projectStore.state.isBusy || this.projectMembersStore.state.isBusy || this.projectAssingmentsStore.state.isBusy}>
            <Row>
                <Col span={10}>
                    <ContentTitle title={t('Projects')} />
                </Col>
                
            </Row>
            <div style={{ padding: 20, marginBottom: 50 }}>
                <GridTableView<ProjectMemberSummary, ProjectTaskSummary, projecttaskassignmentsStore.ProjectTaskAssignmentSummary>
                    onRefresh={this.loadGridData}
                    onSaveItem={this.onSaveNewGridItem}
                    onDeleteItem={this.onDeleteGridItem}
                    xData={membersSpaceMap}
                    yData={tasksSpaceMap}
                    cellData={assingmentsSpaceMap}
                    xDataIndexZ="employeeId"
                    yDataIndexZ="projectTaskId"
                    scroll={{ x: 1500 }}
                />
            </div>       
        </Spin>
    }
}

export default withCache(withTranslation()(withIdentity(withRouter(ProjectTaskAssignmentsDashboard))));
